import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  name: yup.string().required("Vui lòng nhập tên đơn vị tính"),
});
